import React, { createContext, useContext, useMemo } from 'react';
import { OverlayStateProvider } from './OverlayStateProvider';
/** 默认的 Overlay 弹层动画时长 */
var DEFAULT_DURATION = 400;
/** Overlay 状态上下文 */
var OverlayConfigContext = createContext({
    duration: DEFAULT_DURATION,
});
/**
 * 获取 Overlay 配置信息
 *
 * *React Hook*
 */
export var useOverlayConfig = function () { return useContext(OverlayConfigContext); };
export function OverlayConfigProvider(props) {
    var _a = props.duration, duration = _a === void 0 ? DEFAULT_DURATION : _a, children = props.children;
    var value = useMemo(function () { return ({ duration: duration }); }, [duration]);
    return (React.createElement(OverlayConfigContext.Provider, { value: value },
        React.createElement(OverlayStateProvider, null, children)));
}
